<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-4">
        <div class="moduleWrapperUni">
          <div v-if="clipools!=null&&clipools.length>0">
            <div class="moduleCard row">
              <div class="col-12">
                <div class="row">
                  <div class="col-12 text-center">
                    <h3 id="member_details">Member Detail</h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-center">
                    <img v-bind:src="FullImage" class="avatar fullWidth" onerror="this.src='/genericAvatar.png'" />
                  </div>
                  <div class="col-10">
                    <div class="row">
                      <div class="col-12">
                        <button class="btn-transparent" v-show="IsAdmin===true&&adminclipools.length>0" @click="openEditName"><font-awesome-icon icon="edit" aria-label="Edit Name" v-show="!isDisabled"></font-awesome-icon></button> <span v-html="ClientName"></span>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-12">
                        <button class="btn-transparent" v-show="IsAdmin===true&&adminclipools.length>0" @click="openEditEmail"><font-awesome-icon icon="edit" aria-label="Edit Email Address" v-show="!isDisabled"></font-awesome-icon></button> <span v-html="EmailAddress"></span>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-12">
                        <button class="btn-transparent" v-show="IsAdmin===true&&adminclipools.length>0" @click="openEditUser"><font-awesome-icon icon="edit" aria-label="Edit Username" v-show="!isDisabled"></font-awesome-icon></button> <span v-html="Username"></span> <span v-show="!isDisabled">[<a href="javascript:void(0)" @click="doNewMessage" id="message">Message</a>]</span>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="row mt-2">
                  <div class="col-2">&nbsp;</div>
                  <div class="col-5 mt-2 text-left">
                    <span v-show="IsActivated===true" id="account_enabled">Account Enabled</span>
                    <span v-show="IsActivated===false" id="account_disabled">Account Disabled</span>
                    <span v-show="IsAdmin==true&&adminclipools.length>0&&!isDisabled">
                      <br />
                      [<a href="javascript:void(0)" @click="changeAccountStatus"><span v-show="IsActivated===true" id="disable">Disable</span><span v-show="IsActivated===false" id="enable">Enable</span></a>]
                    </span>
                  </div>
                  <div class="col-5 mt-2 text-right" v-show="vID!==null&&IsAdmin===true&&adminclipools.length>0&&!isDisabled">
                    <button class="btn btn-primary" @click="openResetPassword" v-show="vID===emptyguid" id="reset_password">Reset Password</button>
                    <button class="btn btn-primary" @click="doResendVerification" v-show="vID!==emptyguid" id="resend_verification">Resend Verification</button>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="pool in clipools" class="row moduleCard mt-3">
              <div class="col-12">
                <div class="row">
                  <div class="col-8">
                    <button class="btn-transparent lowbold" @click="doExpander(pool)">[<span v-show="pool.IsExpanded===true">-</span><span v-show="pool.IsExpanded===false">+</span>] {{pool.LicensePoolName}}</button>
                  </div>
                  <div class="col-4 text-right">
                    <router-link class="mr-2" :to="{name: 'poolmembers', params:{id:pool.LicensePoolID}}" v-show="pool.IsGroupScope===false" id="go_to_pool">Go to Pool</router-link>
                  </div>
                </div>
                <clientpooldetail v-if="pool.IsExpanded===true" :pool="pool" :isadmin="pool.IsAdmin" :name="Username" :groupscope="pool.IsGroupScope" :groupid="pool.GroupID"></clientpooldetail>
                <div class="row mt-2" v-show="false">
                  <div class="col-12 text-right">
                    <button class="btn btn-danger btn-medium" @click="doRemoveFromPool(pool.LicensePoolID)" id="remove_from_pool">Remove From Pool</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2" v-show="IsAdmin===true&&adminclipools.length>0&&GroupAdminsCanDelete===true">
              <div class="col-12 text-left">
                <button class="btn btn-danger btn-short" @click="doArchiveUser" v-show="!isDisabled" id="archive_user">Archive User</button>
              </div>
            </div>
          </div>
          <div v-show="clipools!=null&&clipools.length===0">
            <p id="member_does_not_belong_license_pool">
              This member does not belong to any license pools. They may have been invited to a pool, but have not accepted yet
            </p>
            <p>
              <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon> <span id="go_back">Go Back</span></a>
            </p>
          </div>
        </div>
      </div>
      <div class="col-8">
        <div class="moduleWrapperUni" v-show="!(clipools!=null&&clipools.length===0)">
          <div>
            <div class="row">
              <div class="col-9 text-center">
                <h3 id="activity_timeline">Activity Timeline</h3>
              </div>
              <div class="col-3 text-right">
                <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon> <span id="back">Back</span></a>
              </div>
            </div>
            <div class="row" v-if="timeline!==null">
              <div class="col-12">
                <div class="row mt-2">
                  <div class="col-12 text-right">
                    <select v-model="Product" @change="doMemberTimeline" class="smallheight nopadding mw" id="filter_by_product">
                      <option v-for="pr in Products" v-bind:value="pr.ProductID">{{pr.ProductName}}</option>
                    </select>
                    &nbsp;&nbsp;
                    <select v-model="Curriculum" @change="doMemberTimeline" class="smallheight nopadding mw" id="filter_by_training_plan">
                      <option v-for="cr in Curricula" v-bind:value="cr.CurriculumID">{{cr.CurriculumName}}</option>
                    </select>
                    &nbsp;&nbsp;
                    <button class="btn btn-secondary btn-short smallheight nopadding topalign ib" @click="openFilterDate" id="filter_by_date">
                      Filter By Date
                    </button>
                    &nbsp;&nbsp;
                    <button class="btn btn-secondary btn-short smallheight nopadding topalign ib" @click="resetFilters" id="reset">
                      Reset
                    </button>
                  </div>
                </div>
                <div class="row mt-2" v-show="timeline.length>0">
                  <div class="col-9">
                    <div class="row mr-1" v-for="entry in timeline">
                      <div class="col-12">
                        <div class="row moduleCard">
                          <div class="col-12">
                            <b name="timeline_activity_date">{{entry.tdate}}</b>
                            <div class="row" v-for="item in entry.items">
                              <div class="col-2">
                                {{item.Time}}
                              </div>
                              <div class="col-4" name="timeline_activity_text">
                                {{item.Text}}
                              </div>
                              <div class="col-3 lowbold" name="timeline_activity_score">
                                {{item.Score}}
                              </div>
                              <div class="col-3 text-right">
                                <span v-show="item.Link!==null">
                                  <a v-bind:href="item.Link" target="_blank" name="transcript">Transcript</a>
                                </span>
                                <span v-show="item.VP!==null&&item.IsStaging!==true">
                                  | <a href="javascript:void(0)" @click="viewPlay(item.VP,item.VS)" onclick="wind=window.open('/waiting.html')" name="play">Play</a>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-show="entry.IsLast===false">
                          <div class="col-12 text-center">
                            |
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="col-3">
                    <div class="row moduleCard" v-if="metrics!==null">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-12 text-center">
                            <span class="lowbold" id="metrics">Metrics</span>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-8" id="total_plays">
                            Total Plays:
                          </div>
                          <div class="col-4 text-right">
                            {{metrics.Plays}}
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-8" id="completions">
                            Completions:
                          </div>
                          <div class="col-4 text-right">
                            {{metrics.Completions}}
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-8" id="average_score">
                            Average Score:
                          </div>
                          <div class="col-4 text-right">
                            {{metrics.AverageScore}}
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-8" id="median_score">
                            Median Score:
                          </div>
                          <div class="col-4 text-right">
                            {{metrics.MedianScore}}
                          </div>
                        </div>

                        <div class="row mt-1">
                          <div class="col-8" id="scored_80_higher">
                            Scored 80 or Higher:
                          </div>
                          <div class="col-4 text-right">
                            {{metrics.ScoresEighty}}
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-8" id="elearning_time">
                            E-Learning Time:
                          </div>
                          <div class="col-4 text-right">
                            {{metrics.ELearningTime}}
                          </div>
                        </div>
                        <div class="row mt-1" id="conversation_time">
                          <div class="col-8">
                            Conversation Time:
                          </div>
                          <div class="col-4 text-right">
                            {{metrics.SimulationTime}}
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-8" id="total_time">
                            Total Time:
                          </div>
                          <div class="col-4 text-right">
                            {{metrics.TotalTime}}
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-8" id="average_of_turns">
                            Average # Turns:
                          </div>
                          <div class="col-4 text-right">
                            {{metrics.AverageTurns}}
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-8" id="median_of_turns">
                            Median # Turns:
                          </div>
                          <div class="col-4 text-right">
                            {{metrics.MedianTurns}}
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="row borderbox mt-2" v-if="cmetrics!==null">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-12 text-center">
                            <span class="lowbold" id="training_paln_metrics">Training Plan Metrics</span>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-12" v-html="cmetrics">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-2" v-show="timeline.length===0" id="no_recorded_timeline">
                  There is no recorded timeline activity for the selected settings
                </div>
              </div>
            </div>
            <div class="row" v-if="timeline===null">
              <div class="col-12">
                Loading...
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal title="Edit Name" ref="editName" @ok="doEditName">
      <div class="row">
        <div class="col-4">
          First Name:
        </div>
        <div class="col-8">
          <input v-model="nFirstName" class="fullWidth" />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-4">
          Last Name:
        </div>
        <div class="col-8">
          <input v-model="nLastName" class="fullWidth" />
        </div>
      </div>
    </b-modal>
    <b-modal title="Edit Username" ref="editUsername" @ok="doEditUsername">
      <div class="row">
        <div class="col-12">
          WARNING! If this user logs in with their username then you will need to inform this user of their new username!
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-4">
          New Username:
        </div>
        <div class="col-8">
          <input v-model="nUsername" class="fullWidth" />
        </div>
      </div>
    </b-modal>
    <b-modal title="Edit Email Address" ref="editEmailAddress" @ok="doEditEmailAddress">
      <div class="row">
        <div class="col-12">
          WARNING! When you change this email address this member will need to re-verify their account and change their password prior to logging in again!
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-4">
          New Email:
        </div>
        <div class="col-8">
          <input v-model="nEmailAddress" class="fullWidth" />
        </div>
      </div>
    </b-modal>
    <b-modal title="Reset Password" ref="resetPassword" @ok="doResetPassword">
      <div class="row">
        <div class="col-12">
          The member's password will be changed immediately. They will not be notified of this change - you will need to notify them.
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-4">
          New Password:
        </div>
        <div class="col-8">
          <input v-model="nPassword" type="password" class="fullWidth" />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-4">
          Retype New Password:
        </div>
        <div class="col-8">
          <input v-model="nRPassword" type="password" class="fullWidth" />
        </div>
      </div>
    </b-modal>
    <b-modal id="ModelFilterByDate" ref="rTime" title="Select Date Range" @ok="doFilterDate">
      <div class="row">
        <div class="col-6 text-center">
          <div id="start_date">Start Date</div>
          <v-date-picker v-model="StartDate" :locale="userLocale"></v-date-picker>
        </div>
        <div class="col-6 text-center">
          <div id="end_date">End Date</div>
          <v-date-picker v-model="FinishDate" :locale="userLocale"></v-date-picker>
        </div>

      </div>
    </b-modal>

    <acfooter></acfooter>
  </div>
</template>

<style scoped>
  .borderbottom {
    border-bottom: 1px solid #666;
  }

  .borders {
    padding: 1%;
    border: 1px dashed #666;
    border-radius: 10px;
  }

  .borderbox {
    padding: 1%;
    border: 1px solid #666;
    border-radius: 10px;
  }

  .lowbold {
    font-weight: 600;
  }

  .timelinebubble {
    padding: 1%;
    border: 1px dashed #666;
    border-radius: 10px;
  }
</style>

<script>
  import "core-js/stable";
  import "regenerator-runtime/runtime";
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import clientpooldetail from "../../components/ClientPoolDetail.vue"

  export default {
    name: 'cliedit',
    components: { acheader, acfooter, clientpooldetail },
    data() {
      return {
        adminclipools: [],
        clipools: null,
        ClientName: null,
        ClientID: null,
        Curricula: [],
        Curriculum: null,
        EmailAddress: null,
        FullImage: null,
        GroupAdminsCanDelete: false,
        IsActivated: null,
        IsAdmin: false,
        Product: null,
        Products: [],
        StartDate: null,
        FinishDate: null,
        cmetrics: null,
        metrics: null,
        timeline: null,
        Username: null,
        nFirstName: null,
        nLastName: null,
        nEmailAddress: null,
        nUsername: null,
        nPassword: null,
        nRPassword: null,
        vID: null,
        userLocale: "en", // Default locale
        isSkillBuilderAssigned: false
      }
    },
    methods: {
      changeAccountStatus() {
        var msg = 'Are you sure you wish to ' + (this.IsActivated ? "deactivate" : "activate") + ' this account?';

        this.$bvModal.msgBoxConfirm(msg, {
          title: 'Confirm Change',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
              {
                Operation: "Client",
                Function: "ChangeActivationStatus",
                Fields: {
                  ClientID: this.$route.params.id,
                  ActivationStatus: this.IsActivated ? "true" : "false"
                }
              }
            ]).then(r => {
              this.popDialog(0, "Activation Status Changed Successfully");
              this.doUserDetails();
            });
          }
        });
      },
      doExpander(pool) {
        if (!pool.IsExpanded) {
          for (var cpool of this.clipools) {
            cpool.IsExpanded = false;
          }
          pool.IsExpanded = true;
        }
        else {
          pool.IsExpanded = false;
        }
        this.$forceUpdate();
      },
      doArchiveUser() {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to archive this account? This action can only be undone by SIMmersion staff', {
          title: 'Confirm Archival',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
              {
                Operation: "Client",
                Function: "ArchiveAccount",
                Fields: {
                  LicensePoolID: this.adminclipools[0].LicensePoolID,
                  ClientID: this.$route.params.id
                }
              }
            ]).then(r => {
              this.popDialog(0, "Member Archived Successfully");
              this.$router.back();
            });
          }
        });
      },
      doMemberTimeline() {
        var cmds = [];
        this.metrics = null;
        this.cmetrics = null;

        for (var pool of this.clipools) {
          cmds.push({
            Operation: "LicensePool",
            Function: "GetUserOperationLog",
            Fields: {
              LicensePoolID: pool.LicensePoolID,
              ClientID: pool.ClientID,
              StartDate: this.StartDate !== null ? this.StartDate : "",
              FinishDate: this.FinishDate !== null ? this.FinishDate : ""
            }
          });
          cmds.push({
            Operation: "LicensePool",
            Function: "GetUserTranscriptHistory",
            Fields: {
              LicensePoolID: pool.LicensePoolID,
              ClientID: pool.ClientID,
              CurriculumID: this.Curriculum ? this.Curriculum : "",
              StartDate: this.StartDate !== null ? this.StartDate : "",
              FinishDate: this.FinishDate !== null ? this.FinishDate : "",
              ProductID: this.Curriculum ? "" : (this.Product !== null ? this.Product : "")
            }
          });

          cmds.push({
            Operation: "LicensePool",
            Function: "GetProductsForUser",
            Fields: {
              LicensePoolID: pool.LicensePoolID,
              ClientID: pool.ClientID,
              IncludeBundles: "true"
            }
          });

          cmds.push(
            {
              Operation: "LicensePool",
              Function: "GetCurricula",
              Fields: {
                LicensePoolID: pool.LicensePoolID,
                ClientID: pool.ClientID,
              }
            });
        }


        if (this.Curriculum !== null) {
          cmds.push({
            Operation: "LicensePool",
            Function: "GetStudentCurriculumProgress",
            Fields: {
              ClientID: this.clipools[0].ClientID,
              CurriculumID: this.Curriculum
            }
          });
        }

        this.apiCommand(cmds).then(response => {

          var cr = JSON.parse(response.CommandResult);

          var x = 0;
          var oplog = [];
          var translog = [];
          this.Products = [];
          this.Curricula = [];


          for (var pool of this.clipools) {

            try {
              //if (this.Product === null) {
              for (var o of JSON.parse(cr.returnObjects[x].returnObject)) {
                oplog.push(o);
              }
              //}
            }
            catch (e) { }

            try {
              for (var t of JSON.parse(cr.returnObjects[x + 1].returnObject)) {
                translog.push(t);
              }
            }
            catch (e) { console.log(e); }          

            try {
              for (var product of JSON.parse(cr.returnObjects[x + 2].returnObject)) {
                if (this.Products.filter(p => p.ProductID === product.ProductID).length === 0) {
                  this.Products.push(product);

                  if (product.ProductID == "28e1498b-0b20-4ed2-b7e4-b6a652b1bc39") //If user assigned to "Crisis Conversation Skill Builders" Product
                  {
                    this.isSkillBuilderAssigned = true;
                  }

                }
              }
            }
            catch (e) { }

            try {
              for (var curriculum of JSON.parse(cr.returnObjects[x + 3].returnObject)) {
                if (this.Curricula.filter(p => p.CurriculumID === curriculum.CurriculumID).length === 0) {
                  this.Curricula.push(curriculum);
                }
              }
            }
            catch (e) { }

            x += 4;




            this.timeline = [];
            var addedList = [];
            var caddedList = [];

            if (oplog.length > 0 || translog.length > 0) {


              for (var entry of oplog) {

                if (addedList.indexOf(entry.OperationID) > -1) {
                  continue;
                }
                else {
                  addedList.push(entry.OperationID);
                }

                var tpDate = this.buildDateTime(entry.OperationDate, false);
                if (tpDate === null) continue;
                var isincluded = false;


                //If user assigned to "Crisis Conversation Skill Builders" Product then hide questionnaire texts
                if (this.isSkillBuilderAssigned == true && entry.OperationText.includes("questionnaire")) {
                  continue;
                }


                for (var day of this.timeline) {
                  if (day.tdate === tpDate) {
                    isincluded = true;
                    day.items.push({ Time: this.buildDateTime(entry.OperationDate, true, true), Text: this.fixOpText(entry.OperationText), Link: null, VP: null, VS: null, IsStaging: null, SDate: entry.OperationDate });
                  }
                }

                if (!isincluded) {
                  this.timeline.push({
                    tdate: tpDate,
                    IsLast: false,
                    sdate: entry.OperationDate,
                    items: [{ Time: this.buildDateTime(entry.OperationDate, true, true), Text: this.fixOpText(entry.OperationText), Link: null, VP: null, VS: null, IsStaging: null, SDate: entry.OperationDate }]
                  })
                }

              }

              var isCurriculumStarted = false;

              for (var entry of translog) {

                if (addedList.indexOf(entry.SessionID) > -1) {
                  continue;
                }
                else {
                  addedList.push(entry.SessionID);
                }

                var tpDate = this.buildDateTime(entry.CreationDate, false);
                if (tpDate === null) continue;

                var isincluded = false;

                var etry = "Started Play of " + entry.ProductName;
                var lnk = this.$hostname + "/Streamable.svc/GetTranscriptPDF?SessionID=" + entry.SessionID + "&ClientID=" + this.$route.params.id;

                for (var day of this.timeline) {
                  if (day.tdate === tpDate) {
                    isincluded = true;
                    if (entry.CourseAttemptNum === 1) {
                      day.items.push({ Time: this.buildDateTime(entry.CreationDate, true, true), Text: "Lesson " + entry.CourseName + " Started", Link: null, VP: null, VS: null, IsStaging: null, SDate: entry.CreationDate });
                      if (!isCurriculumStarted) {
                        isCurriculumStarted = true;
                        day.items.push({ Time: this.buildDateTime(entry.CreationDate, true, true), Text: "Training Plan " + entry.CurriculumName + " Started", Link: null, VP: null, VS: null, IsStaging: null, SDate: entry.CreationDate });
                      }
                    }
                    day.items.push({ Time: this.buildDateTime(entry.CreationDate, true, true), Text: etry, Link: lnk, VP: null, VS: null, IsStaging: null, SDate: entry.CreationDate });
                  }
                }

                if (!isincluded) {
                  this.timeline.push({
                    tdate: tpDate,
                    IsLast: false,
                    sdate: entry.CreationDate,
                    items: [{ Time: this.buildDateTime(entry.CreationDate, true, true), Text: etry, Link: lnk, VP: null, VS: null, IsStaging: null, SDate: entry.CreationDate }]
                  })
                }

              }

              for (var entry of translog) {

                if (caddedList.indexOf(entry.SessionID) > -1) {
                  continue;
                }
                else {
                  caddedList.push(entry.SessionID);
                }

                if (entry.Score !== null) {

                  debugger;
                  var tpDate = this.buildDateTime(entry.CompletionDate, false);
                  if (tpDate === null) continue;

                  var isincluded = false;

                  var lnk = this.$hostname + "/Streamable.svc/GetTranscriptPDF?SessionID=" + entry.SessionID + "&ClientID=" + this.$route.params.id;
                  var etry = "Finished Play of " + entry.ProductName;
                  var score = "[LOP: " + entry.LOP + ", Score: " + entry.Score + ", Language: " + entry.LanguageName.replace("Default To English", "English") + "]";


                  var vpproduct = null;
                  var vpsession = null;
                  if (entry.IsStaging !== true) {
                    vpproduct = entry.ProductID;
                    vpsession = entry.SessionID;
                  }
                  debugger;
                  for (var day of this.timeline) {
                    if (day.tdate === tpDate) {
                      isincluded = true;
                      day.items.push({ Time: this.buildDateTime(entry.CompletionDate, true, true), Text: etry, Score: score, Link: lnk, VP: vpproduct, VS: vpsession, IsStaging: entry.IsStaging, SDate: entry.CompletionDate });
                      if (typeof (entry.CoursePassFail) !== "undefined" && entry.CoursePassFail != null) {
                        day.items.push({ Time: this.buildDateTime(entry.CompletionDate), Text: "Lesson " + entry.CourseName + " " + (entry.CoursePassFail ? "Passed" : "Failed"), Link: null, VP: null, VS: null, IsStaging: null, SDate: entry.CompletionDate });
                      }
                    }
                  }

                  if (!isincluded) {
                    this.timeline.push({
                      tdate: tpDate,
                      IsLast: false,
                      sdate: entry.CreationDate,
                      items: [{ Time: this.buildDateTime(entry.CompletionDate, true, true), Text: etry, Link: lnk, VP: vpproduct, VS: vpsession, IsStaging: entry.IsStaging, SDate: entry.CompletionDate }]
                    })


                    for (var day of this.timeline) {
                      if (day.tdate === tpDate) {
                        isincluded = true;
                        day.items.push({ Time: this.buildDateTime(entry.CompletionDate, true, true), Text: etry, Score: score, Link: lnk, VP: vpproduct, VS: vpsession, IsStaging: entry.IsStaging, SDate: entry.CompletionDate });
                        if (typeof (entry.CoursePassFail) !== "undefined" && entry.CoursePassFail != null) {
                          day.items.push({ Time: this.buildDateTime(entry.CompletionDate), Text: "Lesson " + entry.CourseName + " " + (entry.CoursePassFail ? "Passed" : "Failed"), Link: null, VP: null, VS: null, IsStaging: null, SDate: entry.CompletionDate });
                        }
                      }
                    }

                  }

                }

              }

            }

          }

          if (this.Curriculum !== null) {
            oplog = [];
            this.cmetrics = cr.returnObjects[x].returnObject;
          }

          this.Products.sort(function compare(a, b) {
            let comparison = 0;
            if (a.ProductName > b.ProductName) {
              comparison = 1;
            } else if (a.ProductName < b.ProductName) {
              comparison = -1;
            }
            return comparison;
          });

          this.Products.unshift({
            ProductID: null,
            ProductName: "--- Filter by Product ---"
          });

          this.Curricula.sort(function compare(a, b) {
            let comparison = 0;
            if (a.CurriculumName > b.CurriculumName) {
              comparison = 1;
            } else if (a.CurriculumName < b.CurriculumName) {
              comparison = -1;
            }
            return comparison;
          });

          this.Curricula.unshift({
            CurriculumID: null,
            CurriculumName: "--- Filter by Training Plan ---"
          })

          if (translog.length > 0) {
            var comps = translog.filter(p => p.Score !== null);
            var scores = [], etimes = [], stimes = [], turns = [];
            for (var tscript of translog) {
              scores.push(tscript.Score);
              etimes.push(tscript.ELearningMinutes);
              stimes.push(tscript.SimulationMinutes);
              turns.push(tscript.NumTurns);
            }

            var md = this.median(scores);
            var mt = this.median(turns);

            this.metrics = {
              Plays: translog.length,
              Completions: comps.length,
              AverageScore: comps.length > 0 ? (scores.reduce((a, b) => a + b, 0) / comps.length).toFixed(2) : "N/A",
              MedianScore: md !== null && md.length > 0 ? md : "N/A",
              ScoresEighty: comps.filter(p => p.Score >= 80).length,
              ELearningTime: etimes.reduce((a, b) => a + b, 0),
              SimulationTime: stimes.reduce((a, b) => a + b, 0),
              AverageTurns: (turns.reduce((a, b) => a + b, 0) / turns.length).toFixed(2),
              MedianTurns: mt !== null && mt.length > 0 ? mt : "N/A",
              TotalTime: 0
            }
            this.metrics.TotalTime = this.metrics.ELearningTime + this.metrics.SimulationTime;
          }
          else {
            this.metrics = null;
          }

          for (var entry of this.timeline) {
            entry.items.sort(function compare(a, b) {
              let comparison = 0;
              if (a.SDate > b.SDate) {
                comparison = -1;
              } else if (a.SDate < b.SDate) {
                comparison = 1;
              }
              return comparison;
            });
          }

          this.timeline.sort(function compare(a, b) {
            let comparison = 0;
            if (a.sdate > b.sdate) {
              comparison = -1;
            } else if (a.sdate < b.sdate) {
              comparison = 1;
            }
            return comparison;
          })

          try {
            var l = this.timeline.length - 1;
            this.timeline[l].IsLast = true;
          }
          catch (e) { }

          setTimeout(Window.loadLanguageContent(), 500);
        });

      },
      doEditName() {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "EditClientDetails",
            Fields: {
              LicensePoolID: this.adminclipools[0].LicensePoolID,
              ClientID: this.ClientID,
              FirstName: this.nFirstName,
              LastName: this.nLastName
            }
          }
        ]).then(r => {
          this.popDialog(0, "Details Edited Successfully");
          this.doUserDetails();
        });
      },
      doEditUsername() {

        if (this.nUsername.length < 6) {
          this.popDialog(1, "Username must be 6 or more characters");
          return;
        }

        this.apiCommand([
          {
            Operation: "Client",
            Function: "ChangeUsername",
            Fields: {
              ClientID: this.ClientID,
              LicensePoolID: this.adminclipools[0].LicensePoolID,
              NewUsername: this.nUsername
            }
          }
        ]).then(r => {

          var cr = JSON.parse(r.CommandResult);
          if (cr.returnObjects[0].returnObject == "OK") {
            this.popDialog(0, "Username Changed Successfully");
            this.doUserDetails();
          }
          else {
            this.popDialog(1, cr.returnObjects[0].returnObject);
          }

        })
      },
      doEditEmailAddress() {
        this.apiCommand([
          {
            Operation: "Client",
            Function: "ChangeEmailAddress",
            Fields: {
              ClientID: this.ClientID,
              LicensePoolID: this.adminclipools[0].LicensePoolID,
              NewEmail: this.nEmailAddress
            }
          }
        ]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          if (cr.returnObjects[0].returnObject == "OK") {
            this.popDialog(0, "Email Address Changed Successfully");
            this.doUserDetails();
          }
          else {
            this.popDialog(1, cr.returnObjects[0].returnObject);
          }
        });
      },
      doFilterDate() {
        this.doMemberTimeline();
      },
      doNewMessage() {
        this.$router.push("/client/newmessage/" + this.ClientID);
      },
      doResendVerification() {
        this.apiCommand([
          {
            Operation: "Client",
            Function: "SendVerificationEmail",
            Fields: {
              VerificationID: this.vID
            }
          }
        ]).then(r => {

          var cr = JSON.parse(r.CommandResult);

          if (cr.returnObjects[0].returnObject == "OK") {
            this.popDialog(0, "Verification Email Sent");
          }
          else {
            this.popDialog(1, cr.returnObjects[0].returnObject);
          }

        });
      },
      doRemoveFromPool(poolID) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to remove this user from the pool?', {
          title: 'Confirm Remove From Pool',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "DeleteMember",
                Fields: {
                  LicensePoolID: poolID,
                  ClientID: this.$route.params.id
                }
              }
            ]).then(r => {
              this.popDialog(0, "Member Removed From Pool Successfully");
              this.$router.back();
            });
          }
        });
      },
      doResetPassword() {
        if (this.nPassword.length < 11) {
          this.popDialog(1, "The new password must be at least 11 characters");
        }
        if (this.nRPassword !== this.nPassword) {
          this.popDialog(1, "The new password and re-typed new password do not match");
        }

        this.apiCommand([{
          Operation: "LicensePool",
          Function: "EditClientPassword",
          Fields: {
            LicensePoolID: this.adminclipools[0].LicensePoolID,
            ClientID: this.ClientID,
            NewPassword: this.nPassword
          }
        }
        ]).then(r => {
          this.popDialog(0, "Password Changed Successfully");
        });
      },
      doUserDetails() {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetUserDetails",
            Fields: {
              LicensePoolID: this.clipools[0].LicensePoolID,
              ClientID: this.$route.params.id
            }
          }
        ]).then(r => {

          var cr = JSON.parse(r.CommandResult);
          var ud = JSON.parse(cr.returnObjects[0].returnObject);

          this.FullImage = "https://attachments.simmersion.com/" + ud.ClientID + ".png";
          this.ClientName = this.buildNameFormat(ud.FirstName, ud.LastName).trim();
          if (this.ClientName.length === 0) {
            this.ClientName = "<i id='not_set'>Not Set</i>";
          }
          if (ud.EmailAddress.length > 0) {
            this.EmailAddress = ud.EmailAddress;
          }
          else {
            this.EmailAddress = "<i id='not_set'>Not Set</i>";
          }

          this.Username = ud.Username;
          this.ClientID = ud.ClientID;
          this.nFirstName = ud.FirstName;
          this.nLastName = ud.LastName;
          this.nUsername = ud.Username;
          this.nEmailAddress = ud.EmailAddress;
          this.IsActivated = !ud.IsDisabled;
          this.vID = ud.VerificationID;

          //setTimeout(Window.loadLanguageContent(), 5000);

        });
      },
      openEditName() {
        this.$refs["editName"].show();
      },
      openEditEmail() {
        this.$refs["editEmailAddress"].show();
      },
      openEditUser() {
        this.$refs["editUsername"].show();
      },
      openFilterDate() {
        this.$refs["rTime"].show();

        const userLanguage = sessionStorage.getItem("userLanguage");
        if (userLanguage) {
          this.userLocale = userLanguage === "Espanol" ? "es" : "en"; // Default to English if not "Espanol"
        }
        setTimeout(Window.loadLanguageContent(), 5000);
      },
      openResetPassword() {
        this.$refs["resetPassword"].show();
      },
      resetFilters() {
        this.StartDate = null;
        this.FinishDate = null;
        this.Product = null;
        this.Curriculum = null;
        this.doMemberTimeline();
      },
      goBack() {
        this.$router.back();
      },
      viewPlay(productID, resumeSession) {

        var simLoginFields = {
          ProductID: productID,
          useCurricula: "false",
          ResumeSession: resumeSession
        };

        this.apiCommand([
          {
            Operation: "Client",
            Function: "SimulationLogin",
            Fields: simLoginFields
          }
        ]).then(r => {
          var cr = JSON.parse(r.CommandResult);

          if (cr.returnObjects[0].returnObject.indexOf("http") > -1) {

            wind.location.href = cr.returnObjects[0].returnObject;
          }
          else {
            wind.close();
            this.popDialog(1, cr.returnObjects[0].returnObject);
          }

        })

      }
    },
    mounted() {
      this.doPage().then(r => {
        this.bootstrapClient(this.udata.ClientID);

        this.apiCommand([
          {
            Operation: "Client",
            Function: "GetLicensePoolsForClient",
            Fields: {
              ClientID: this.$route.params.id
            }
          }
        ]).then(pooldata => {

          var pr = JSON.parse(pooldata.CommandResult);
          var isFirst = true;

          this.clipools = [];
          this.adminclipools = [];

          for (var clipool of JSON.parse(pr.returnObjects[0].returnObject)) {
            clipool.IsGroupScope = false;
            if (this.clipools.filter(p => p.LicensePoolID === clipool.LicensePoolID).length === 0) {
              var pools = this.sdata.allpools.filter(p => p.LicensePoolID === clipool.LicensePoolID);
              if (pools.length > 0) {
                if (pools[0].IsAdmin) {
                  this.IsAdmin = true;
                  clipool.IsAdmin = true;
                  this.GroupAdminsCanDelete = true;
                  this.adminclipools.push(clipool);
                }

                if (isFirst) {
                  clipool.IsExpanded = true;
                  isFirst = false;
                }
                else {
                  clipool.IsExpanded = false;
                }
                this.clipools.push(clipool);
              }
            }
            if (this.clipools.filter(p => p.LicensePoolID === clipool.LicensePoolID).length === 0) {
              var grppools = this.sdata.allgroups.filter(p => p.LicensePoolID === clipool.LicensePoolID);
              if (grppools.length > 0) {

                if (grppools[0].IsAdmin) {
                  this.IsAdmin = true;
                  clipool.IsAdmin = true;
                  clipool.IsGroupScope = true;
                  clipool.GroupID = grppools[0].LicensePoolGroupID;
                  this.adminclipools.push(clipool);
                }

                if (isFirst) {
                  clipool.IsExpanded = true;
                  isFirst = false;
                }
                else {
                  clipool.IsExpanded = false;
                }
                this.clipools.push(clipool);
              }
            }


          }

          if (this.clipools.length > 0) {

            if (this.adminclipools.length > 0 && this.GroupAdminsCanDelete === false) {
              this.GroupAdminsCanDelete = true;
              for (var c of this.adminclipools) {
                if (c.GroupAdminsCanDelete !== true) {
                  this.GroupAdminsCanDelete = false;
                }
              }
            }

            this.doUserDetails();
            this.doMemberTimeline();



          }
        });
        if (sessionStorage.getItem("isSimmersionUser")) {
          this.popDialog(2, "Account management is handled at the organization level. To make account related changes, please log into the Lifeline Learning Portal and visit the Users page.");
        }
      });

    },
    computed: {
      isDisabled() {
        if (sessionStorage.getItem("isSimmersionUser")) {
          return true;
        }
        else {
          return false;
        }
      }
    }
  }
</script>
